








































































































































































import { Component, Watch, Mixins } from "vue-property-decorator"
import api from "../honcierge-api"
import ArticleSearchForm from "@/components/ArticleSearchForm.vue"
import EditableMixin from "../mixins/editable-mixin"
import FrontUrlMixin from "../mixins/front-url-mixins"
import { mapState } from "vuex"
import { AxiosError } from "axios"
import { ArticleSearchMaster, SearchResultArticle } from "types/index"
import { DataTableHeader } from "vuetify/types"

@Component({
  components: { ArticleSearchForm },
  computed: {
    ...mapState("adminUser", { adminUserId: "id", role: "role" }),
  },
})
export default class Articles extends Mixins(EditableMixin, FrontUrlMixin) {
  private loading = true
  private totalPages = 0
  private articles: SearchResultArticle[] = []
  private search = ""
  private role!: string
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }
  private articleSearchMaster: ArticleSearchMaster["searchMaster"] = {
    statuses: [],
    editors: [],
    writers: [],
    categories: [],
    appAffiliates: [],
  }

  get headers(): DataTableHeader[] {
    const headers: DataTableHeader[] = [
      { text: "ID", value: "id" },
      { text: "タイトル", value: "title" },
      { text: "ステータス", value: "status" },
    ]
    if (this.isWriter) {
      headers.push({ text: "最終更新日", value: "updatedAt" })
    } else if (this.isEditor) {
      headers.push(
        ...[
          { text: "ライター", value: "writer" },
          { text: "最終更新日", value: "updatedAt" },
        ]
      )
    } else {
      // administrator
      headers.push(
        ...[
          { text: "ライター", value: "writer" },
          { text: "編集者", value: "editor" },
          { text: "最終更新日", value: "updatedAt" },
          { text: "公開日", value: "publishedAt" },
          { text: "公開終了日", value: "endOfPublishedAt" },
        ]
      )
    }
    headers.push({ text: "操作", value: "action", sortable: false })
    return headers
  }

  get fields(): DataTableHeader["value"][] {
    return this.headers.map((header) => header.value)
  }

  public searchResult(result: SearchResultArticle[], totalPages: number): void {
    this.articles = result
    this.totalPages = totalPages
  }

  private savePublishedAtOrEndOfPublishedAt(
    articleId: number,
    publishedAt: string,
    endOfPublishedAt: string,
    editable: boolean
  ) {
    if (!editable) {
      this.$toasted.error(
        "公開待ち、公開、公開終了ステータスでは変更できません"
      )
      return
    }

    api
      .changePublishDate(articleId, publishedAt, endOfPublishedAt)
      .then(() => {
        this.$toasted.success("日付を変更しました")
      })
      .catch((e: AxiosError) => {
        if (e.response) {
          this.$toasted.error(e.response.data.messages)
        }
        this.getArticles()
      })
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private getArticles() {
    this.loading = true
    setTimeout(() => {
      try {
        const articleSearchForm = this.$refs.articleSearchForm as InstanceType<
          typeof ArticleSearchForm
        >
        const pagination = this.pagination
        articleSearchForm.search(
          pagination.page,
          pagination.itemsPerPage,
          pagination.sortBy[0],
          pagination.sortDesc[0]
        )
        this.loading = false
      } catch (e) {
        console.error(e)
      }
    }, 500)
  }

  private created() {
    api
      .adminSearchMasters()
      .then((res) => {
        const result = res.data.searchMaster
        this.articleSearchMaster.statuses = result.articleStatuses
        this.articleSearchMaster.editors = result.editors
        this.articleSearchMaster.writers = result.writers
        this.articleSearchMaster.categories = result.categories
        this.articleSearchMaster.appAffiliates = result.appAffiliates
      })
      .catch((e: AxiosError) => {
        console.log(e.stack)
      })
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  private get isWriter(): boolean {
    return this.role === "writer"
  }

  private get isEditor(): boolean {
    return this.role === "editor"
  }

  private get isAdministrator(): boolean {
    return this.role === "administrator"
  }
}
